import { FiUser, FiActivity, FiCalendar } from "react-icons/fi";
import { Student } from "../../../types";

interface StudentsStatsCardsProps {
  students: Student[];
  isValidityExpired: (validity: string) => boolean;
}

function StudentsStatsCards({
  students,
  isValidityExpired,
}: StudentsStatsCardsProps) {
  const activePlans = students.filter(
    (s) => !isValidityExpired(s.validity),
  ).length;

  const expiringIn7Days = students.filter((s) => {
    if (!s.validity) return false;
    const diff = Math.ceil(
      (new Date(s.validity).getTime() - new Date().getTime()) /
        (1000 * 60 * 60 * 24),
    );
    return diff > 0 && diff <= 7;
  }).length;

  const expiredPlans = students.filter((s) =>
    isValidityExpired(s.validity),
  ).length;

  const statsConfig = [
    {
      label: "Total de Alunos",
      value: students.length,
      icon: <FiUser className="text-white" size={24} />,
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      shadowColor: "rgba(102, 126, 234, 0.5)",
    },
    {
      label: "Planos Ativos",
      value: activePlans,
      icon: <FiActivity className="text-white" size={24} />,
      gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
      shadowColor: "rgba(67, 233, 123, 0.5)",
    },
    {
      label: "Vencendo em 7 dias",
      value: expiringIn7Days,
      icon: <FiCalendar className="text-white" size={24} />,
      gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      shadowColor: "rgba(250, 112, 154, 0.5)",
    },
    {
      label: "Planos Expirados",
      value: expiredPlans,
      icon: <FiCalendar className="text-white" size={24} />,
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      shadowColor: "rgba(240, 147, 251, 0.5)",
    },
  ];

  return (
    <div className="mb-4 grid grid-cols-2 gap-3 sm:mb-6 sm:gap-4 lg:grid-cols-4">
      {statsConfig.map((stat, index) => (
        <div
          key={index}
          className="group rounded-xl border border-gray-200 bg-gradient-to-br from-white to-gray-50 p-3 shadow-sm transition-all duration-300 hover:shadow-xl dark:border-gray-800 dark:from-white/[0.03] dark:to-white/[0.01] sm:rounded-2xl sm:p-5"
        >
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
            <div
              className="rounded-lg p-2 transition-transform duration-300 group-hover:scale-110 sm:rounded-xl sm:p-3"
              style={{
                background: stat.gradient,
                boxShadow: `0 10px 25px -5px ${stat.shadowColor}`,
              }}
            >
              {stat.icon}
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 sm:text-sm">
                {stat.label}
              </p>
              <p
                className="bg-clip-text text-2xl font-bold text-transparent sm:text-3xl"
                style={{ backgroundImage: stat.gradient }}
              >
                {stat.value}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default StudentsStatsCards;
